// Types
import { RootState } from 'types/RootState.types';

//
import { COLLECTOR_DETAILS_FORM_ID } from '../form/configs/collectorDetails';
import { checkIsUkMobileNumber } from '../address/addressHelpers';
import { ukMobileNumberRequired } from './ukMobileNumberRequired';

export function getCollectionPhoneNumber(state: RootState) {
  const {
    clickAndCollect: {
      confirmedCollectorDetails: {
        collectorDetails: {
          primaryPhone: confirmedPhoneNumber = '',
        } = {},
      } = {},
    } = {},
    form: {
      [COLLECTOR_DETAILS_FORM_ID]: {
        values: {
          phoneNumber: formValuePhoneNumber = '',
        } = {},
      } = {},
    } = {},
    user: {
      defaultAddress: {
        phoneNumber: defaultContactPhoneNumber = '',
      } = {},
    } = {},
  } = state ?? {};

  const phoneNumber = confirmedPhoneNumber || formValuePhoneNumber || defaultContactPhoneNumber;

  if (ukMobileNumberRequired(state) && !checkIsUkMobileNumber(phoneNumber)) return '';

  return phoneNumber;
}
